Vue.component('response-suggestion', {
  props: ['review', 'user', 'respond_url'],
  /*html*/
  template: `    
  <div class="hint-section">
        <div class="hint-section-edit">
            <h5 class="header-case">{{ __('Response Suggestion') }} <span class="blue-text"></span>
            </h5>
            <div class="d-flex justify-content-between align-items-center mb-3">
                <a v-if="commentUpdatedAtBy">
                    Last edited by:
                    <span v-text="commentUpdatedAtBy"></span>
                </a>
            </div>

            <div class="response-suggestion-wrapper">
                <textarea dir="ltr" class="hint-display p-2 my-3" id="responseText" v-model="response"></textarea>
                <div class="floating-section d-flex flex-column">
                    <button  class="btn btn-default btn-round my-1" @click="copyText()" data-placement="top" data-toggle="tooltip" :title="hintTitle">
                        <i class="far fa-copy blue-text"></i>
                    </button>
                      <button :title="externalLink" class="btn btn-default btn-round my-1" data-toggle="tooltip" @click="redirectToRespondURL">
                        <i class="fas fa-external-link-alt blue-text"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="hint-options d-flex align-items-start mr-5">

                <button type="button" class="btn btn-primary btn-large"
                    v-on:click="saveResponseSuggestion">Save
                </button>
        </div>
    </div>
  
  `,
  data() {
    return {
      isResponseSuggestion: false,
      commentUpdatedAtBy: '',
      response: '',
      hintTitle: 'Click to copy',
      externalLink: 'Click to redirect to review source',
      suggestionComment: null,
    };
  },
  mounted() {
    this.initializeSuggestion();
    navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
      if (result.state == 'granted' || result.state == 'prompt') {
        /* clipboard write permission granted */
      }
    });
  },
  methods: {
    redirectToRespondURL() {
      window.open(this.respond_url, '_blank');
    },
    initializeSuggestion() {
      this.suggestionComment = this.review.comments.find((comment) => comment.kind === 'suggestion');
      if (this.suggestionComment) {
        this.response = this.suggestionComment.comment;
        this.commentUpdatedAtBy = this.suggestionComment.updated_by;
      }
    },
    copyText() {
      let textArea = document.createElement('textarea');
      textArea.value = this.response;
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        this.hintTitle = 'Copied !';
      } catch (err) {
        alert('Oops!','Failed to copy text','danger');
      }
      document.body.removeChild(textArea);
    },

    async saveResponseSuggestion() {
      try {
        const { id: reviewId, team_id: teamId } = this.review;
        const commentSuggestion = this.response;

        await axios.post(`/api/reviews/${teamId}/${reviewId}/responseSuggestion`, { commentSuggestion });

        // Retrieve the updated comment
        const response = await axios.get(`/api/reviews/${reviewId}/comments`);

        // Update the comments in the review object
        Vue.set(this.review, 'comments', response.data.comments);
        this.toggleResponseArea();

        // Update the commentUpdatedAtBy property
        const updatedComment = response.data.comments.find((comment) => comment.kind === 'suggestion');
        if (updatedComment) {
          Vue.set(this.review, 'commentUpdatedAtBy', updatedComment.updated_by);
          this.commentUpdatedAtBy = updatedComment.updated_by;
        }

        this.$emit('response-suggestion-saved');
      } catch (error) {
        console.log(error);
        alert('Oops!','Failed to save comment suggestion','danger');
        this.isResponseSuggestion = true;
      }
    },
    toggleResponseArea() {
      this.isResponseSuggestion = !this.isResponseSuggestion;
    },
  },
});
